import { CSSProperties } from 'react';

export const languageItemStyle: CSSProperties = {
  padding: '2px',
  borderRadius: '14px',
  marginBottom: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
};

export const selectedItemMarkStyle: CSSProperties = {
  width: '24px',
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: '600',
  color: '#FFFFFF',
  backgroundColor: '#1A1A1A',
  borderRadius: '50%',
  marginRight: '12px'
};
